import moment, { duration } from 'moment';

export const secondsToTimePoint = (value: number) => {
  /*
   * Converts number of seconds into "hh:mm:ss" format
   */
  const d = duration(value, 'second');
  return moment().startOf('day').add(d).format('HH:mm:ss');
};
